// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

const oldIconNames = {
  'i-filter-02': 'filter',
  'i-filter-check-mark': 'filter-check-mark',
  'i-sliders': 'sliders',
  'i-two-sheets-blank': 'copy',
  'i-server-refresh': 'backup',
  'i-two-arrows-refresh-04': 'refresh',
  'i-circle-check-mark': 'check-mark-circle',
  'i-check-mark': 'check-mark',
  'i-three-dots': 'three-dots-horizontal',
  'tree-dots-horizontal': 'three-dots-horizontal',
  'i-square-arrow-up-04': 'arrow-up-in',
  'i-square-arrow-down-04': 'arrow-down-in',
  'i-shield-star': 'shield',
  'i-menu': 'menu',
  'i-folder-blank-closed-02': 'folder-closed',
  'i-arrow-refresh-02': 'reload',
  'i-eye-03': 'eye-closed',
  'i-www-site-picture-text': 'site-page',
  'i-broken-chain': 'chain-broken',
  'i-eye-02': 'eye',
  'i-arrows-looping-06': 'arrows-loop',
  'i-circle-question-mark-02': 'question-mark-circle-filled',
  'i-circle-check-mark-02': 'check-mark-circle-filled',
  'i-circle-info-02': 'info-circle-filled',
  'i-circle-exclamation-mark-02': 'exclamation-mark-circle-filled',
  'i-magnifying-glass': 'search',
  'i-circle-exclamation-mark': 'exclamation-mark-circle',
  'i-cross-mark': 'cross-mark',
  'i-plus': 'plus',
  'i-circle-question-mark': 'question-mark-circle',
  'i-arrow-up-07': 'chevron-down',
  'i-arrow-down-07': 'chevron-up',
  'i-arrow-right-07': 'chevron-right',
  'i-arrow-left-07': 'chevron-left',
  'i-arrow-up-06': 'arrow-up-tray',
  'i-arrow-down-06': 'arrow-down-tray',
  'i-trashcan': 'remove',
  'i-four-squares': 'four-squares',
  'i-shopping-cart-02': 'shopping-cart',
  'i-chain': 'chain',
  'i-gear': 'gear',
  'i-list': 'list',
  'i-pencil': 'pencil',
  'i-circle-cross-mark': 'clean',
  'i-circle-minus': 'minus-circle',
  'i-circle-info': 'info-circle',
  'i-folder-blank-open': 'folder-open',
  world: 'globe',
  'circle-check-mark': 'check-mark-circle',
  'circle-check-mark-filled': 'check-mark-circle-filled',
  'circle-exclamation-mark': 'exclamation-mark-circle',
  'circle-exclamation-mark-filled': 'exclamation-mark-circle-filled',
  'circle-info': 'info-circle',
  'circle-info-filled': 'info-circle-filled',
  'circle-minus': 'minus-circle',
  'circle-question-mark': 'question-mark-circle',
  'circle-question-mark-filled': 'question-mark-circle-filled',
  sertificate: 'ribbon'
};
export default oldIconNames;